import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SegmentationService } from '@modules/segments/services/segments.service';

@Injectable({ providedIn: 'root' })
export class SegmentFilterService {
  private prefix = 'DATA.MODULES.CAMPAINGS.SEGMENTS.MODAL';

  constructor(
    private translate: TranslateService,
    private segmentService: SegmentationService,
  ) {}

  getCollectorNames(collectorIds: string[], collectors: any[]): string {
    return collectorIds
      .map((id) => collectors.find((c: { id: string }) => c.id === id)?.name || id)
      .join(', ');
  }

  getGenderNames(genders: string[]): string {
    return genders
      .map(
        (id) =>
          this.segmentService.getGenderOptions().find((c: { value: string }) => c.value === id)
            ?.label || id,
      )
      .join(', ');
  }

  getPortfolioNames(portfolioIds: string[], portfolios: any[]): string {
    return portfolioIds
      .map((id) => portfolios.find((p: { id: string }) => p.id === id)?.name || id)
      .join(', ');
  }

  getIsCompany(isCompany: boolean): string {
    return isCompany
      ? this.translate.instant('DATA.COMMON.OWNER.PRIVATE')
      : this.translate.instant('DATA.COMMON.OWNER.BUSINESS');
  }

  getFilterText(filter: any, collectors: any[], portfolios: any[]): string {
    if (!filter) return '';

    switch (filter.type) {
      case 'custom_field':
        return this.translate.instant(`${this.prefix}.CUSTOM_FIELD`, {
          field: filter.value.field ?? '-',
          value: filter.value.value ?? '-',
        });
      case 'collector_ids':
        return this.translate.instant(`${this.prefix}.COLLECTOR_IDS`, {
          collectors: this.getCollectorNames(filter.value.collectorIds, collectors),
        });
      case 'portfolio_ids':
        return this.translate.instant(`${this.prefix}.PORTFOLIO_IDS`, {
          portfolios: this.getPortfolioNames(filter.value.portfolioIds, portfolios),
        });
      case 'customer_case_pending_amount':
        return this.translate.instant(`${this.prefix}.CUSTOMER_CASE_PENDING_AMOUNT`, {
          minAmount: filter.value.min.amount / 100 ?? '-',
          minCurrency: filter.value.min.currency ?? '-',
          maxAmount: filter.value.max.amount / 100 ?? '-',
          maxCurrency: filter.value.max.currency ?? '-',
        });
      case 'customer_case_overdue_days':
        return this.translate.instant(`${this.prefix}.CUSTOMER_CASE_OVERDUE_DAYS`, {
          minDays: filter.value.min ?? '-',
          maxDays: filter.value.max ?? '-',
        });
      case 'customer_case_number_of_payable_operations':
        return this.translate.instant(`${this.prefix}.CUSTOMER_CASE_NUMBER_OF_PAYABLE_OPERATIONS`, {
          minOperations: filter.value.min ?? '-',
          maxOperations: filter.value.max ?? '-',
        });
      case 'customer_age':
        return this.translate.instant(`${this.prefix}.CUSTOMER_AGE`, {
          minAge: filter.value.min ?? '-',
          maxAge: filter.value.max ?? '-',
        });
      case 'customer_is_company':
        return this.translate.instant(`${this.prefix}.CUSTOMER_IS_COMPANY`, {
          ownership: this.getIsCompany(filter.value),
        });
      case 'customer_gender':
        return this.translate.instant(`${this.prefix}.CUSTOMER_GENDER`, {
          genders: this.getGenderNames(filter.value),
        });
      default:
        return this.translate.instant(`${this.prefix}.DEFAULT`, {
          type: filter.type,
          value: JSON.stringify(filter.value),
        });
    }
  }
}
